import { createActionCreator } from "common/ReduxUtils";

export enum BladeActionTypes {
  SHOW_BLADE = "SHOW_BLADE",
  HIDE_BLADE = "HIDE_BLADE",
}

export const showBladeAction = createActionCreator<string>(BladeActionTypes.SHOW_BLADE, "id");
export const hideBladeAction = createActionCreator<string>(BladeActionTypes.HIDE_BLADE, "id");
